import React from 'react';
import Main from './pages/Main';
import './App.css';
export default function App(){return <Main/>;}
